import { Calendar, MapPin } from "lucide-react";

export const EventsSection = ({ events }) => {
  return (
    <section id="events" className="py-20 bg-gray-50" data-testid="events-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="events-title"
          >
            Upcoming Events
          </h2>
          <div className="w-24 h-1 bg-amber-600 mx-auto mb-6"></div>
          <p
            className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Join us for these special gatherings and be part of something transformative
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {events.map((event, index) => (
            <div
              key={event.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all hover:-translate-y-1 overflow-hidden"
              data-testid={`event-card-${index}`}
            >
              <div className="bg-gradient-to-r from-amber-600 to-amber-700 p-6">
                <h3
                  className="text-2xl font-bold text-white mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                  data-testid={`event-title-${index}`}
                >
                  {event.title}
                </h3>
              </div>
              <div className="p-6">
                <p
                  className="text-gray-700 mb-4 leading-relaxed text-sm"
                  style={{ fontFamily: "'Crimson Text', serif" }}
                  data-testid={`event-description-${index}`}
                >
                  {event.description}
                </p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-gray-600" data-testid={`event-date-${index}`}>
                    <Calendar size={18} className="text-amber-600" />
                    <span className="text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>{event.date}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-600" data-testid={`event-location-${index}`}>
                    <MapPin size={18} className="text-amber-600" />
                    <span className="text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>{event.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};